/* BGT AU v3 — khối cá nhân hoá trang SP (snippets/bgt-personalise.liquid).
   - Đếm ký tự, chặn ký tự không in được (emoji...), kiểm ảnh (loại / dung lượng / độ phân giải)
   - Tick xác nhận bắt buộc -> ghi properties[_Confirmed]
   - Khoá nút thêm giỏ (aria-disabled, KHÔNG đụng `disabled` vì Minimog dùng nó cho hết hàng); bấm khi chưa đủ -> báo lỗi + cuộn tới ô
   - Đổi chữ nút thành CTA cá nhân hoá (Minimog đổi lại khi chọn biến thể -> MutationObserver giữ chữ)
   - Thanh sticky có form riêng không mang properties -> chặn, chuyển sang nộp form chính
   Chạy cả khi file nạp nhiều lần (customElements.get). */
(() => {
  if (customElements.get('bgt-personalise')) return;
  // Chữ in được: chữ cái mọi ngôn ngữ Latin, số, khoảng trắng và vài dấu thường gặp trên áo
  const ALLOWED = /^[\p{Script=Latin}0-9 '&.,!?#@+\-()\/:"’]*$/u;
  const BAD = /[^\p{Script=Latin}0-9 '&.,!?#@+\-()\/:"’]/gu; // dùng cho replace (cờ g)
  const HAS_BAD = /[^\p{Script=Latin}0-9 '&.,!?#@+\-()\/:"’]/u; // dùng cho test (không cờ g -> không dính lastIndex)
  const MSG = {
    empty: 'Please enter the text to print.',
    chars: 'Only letters, numbers and basic punctuation can be printed (no emoji).',
    noFile: 'Please upload a photo.',
    type: 'Please upload a JPG or PNG photo.',
    size: (mb) => `This photo is over ${mb} MB. Please choose a smaller one.`,
    read: "We couldn't read this photo. Please try another one.",
    low: (w, h) => `This photo is small (${w}×${h}px), so it may print blurry. A larger photo works best.`,
    confirm: 'Please tick to confirm your personalisation.',
  };

  class BgtPersonalise extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form) return;
      this.cta = this.dataset.cta || 'Personalise & Add to Cart';
      this.maxMb = Number(this.dataset.maxMb) || 10;
      this.minPx = Number(this.dataset.minPx) || 800;
      this.texts = [...this.querySelectorAll('[data-bgt-text]')];
      this.photo = this.querySelector('[data-bgt-photo]');
      this.check = this.querySelector('.bgt-pers__check');
      this.confirmValue = this.querySelector('[data-bgt-confirm-value]');
      this.photoOk = !this.photo; // không có ô ảnh = đạt
      this.touched = false;

      this.texts.forEach((f) => {
        const input = f.querySelector('input');
        input.addEventListener('input', () => this.onText(f));
        input.addEventListener('blur', () => { input.value = input.value.trim().replace(/\s{2,}/g, ' '); this.onText(f); });
      });
      if (this.photo) this.photo.querySelector('input[type=file]').addEventListener('change', (e) => this.onFile(e.target));
      this.check.addEventListener('change', () => { this.confirmValue.value = this.check.checked ? 'Yes' : ''; this.setErr(this.check.closest('[data-bgt-confirm]'), ''); this.refresh(); });

      // Chặn nộp form khi chưa đủ — capture ở document để chạy TRƯỚC ProductForm của Minimog
      this._onSubmit = (e) => {
        if (e.target !== this.form) return;
        if (!this.validate(true)) { e.preventDefault(); e.stopImmediatePropagation(); }
      };
      document.addEventListener('submit', this._onSubmit, true);

      // Thanh sticky: form riêng, không mang ô cá nhân hoá -> chuyển sang form chính
      this._onStickyClick = (e) => {
        const btn = e.target.closest('.sticky-atc-form [name="add"], .m-sticky-addtocart [name="add"]');
        if (!btn) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (!this.validate(true)) return;
        const main = this.form.querySelector('[name="add"]');
        if (this.form.requestSubmit) this.form.requestSubmit(main || undefined); else main && main.click();
      };
      document.addEventListener('click', this._onStickyClick, true);

      this.buttons().forEach((b) => this.watchLabel(b));
      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this._onSubmit, true);
      document.removeEventListener('click', this._onStickyClick, true);
      (this._observers || []).forEach((o) => o.disconnect());
    }

    buttons() {
      return [this.form.querySelector('[name="add"]'), ...document.querySelectorAll('.sticky-atc-form [name="add"], .m-sticky-addtocart [name="add"]')].filter(Boolean);
    }

    // Giữ chữ CTA: Minimog ghi lại "Add to cart" khi đổi biến thể; chữ "Sold out"/"Unavailable" thì để nguyên
    watchLabel(btn) {
      const span = btn.querySelector('.m-add-to-cart--text') || btn;
      const addText = (window.MinimogStrings && window.MinimogStrings.addToCart) || 'Add to cart';
      const apply = () => {
        const t = span.textContent.trim();
        if (t && t.toLowerCase() === addText.trim().toLowerCase() && t !== this.cta) span.textContent = this.cta;
      };
      apply();
      btn.setAttribute('data-atc-text', this.cta);
      const o = new MutationObserver(apply);
      o.observe(span, { childList: true, characterData: true, subtree: true });
      (this._observers = this._observers || []).push(o);
    }

    setErr(field, msg) {
      const el = field && field.querySelector('[data-bgt-err]');
      if (!el) return;
      el.textContent = msg; el.hidden = !msg;
      const input = field.querySelector('input:not([type=hidden])');
      if (input) input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      field.classList.toggle('is-error', !!msg);
    }

    onText(f) {
      const input = f.querySelector('input');
      const max = Number(input.maxLength) || 15;
      if (HAS_BAD.test(input.value)) {
        input.value = input.value.replace(BAD, '');
        this.setErr(f, MSG.chars);
      } else if (f.classList.contains('is-error') && input.value.trim()) {
        this.setErr(f, '');
      }
      const n = [...input.value].length;
      const c = f.querySelector('[data-bgt-count]');
      if (c) { c.textContent = `${n}/${max}`; c.classList.toggle('is-max', n >= max); }
      this.refresh();
    }

    onFile(input) {
      const f = this.photo;
      const thumb = f.querySelector('[data-bgt-thumb]');
      const warn = f.querySelector('[data-bgt-warn]');
      warn.hidden = true; thumb.hidden = true; this.photoOk = false;
      const file = input.files && input.files[0];
      const fail = (m) => { input.value = ''; this.setErr(f, m); this.refresh(); };
      if (!file) return fail(MSG.noFile);
      if (!/^image\/(jpeg|png)$/.test(file.type)) return fail(MSG.type);
      if (file.size > this.maxMb * 1024 * 1024) return fail(MSG.size(this.maxMb));
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        const w = img.naturalWidth, h = img.naturalHeight;
        thumb.src = url; thumb.hidden = false; thumb.alt = 'Your photo preview';
        if (Math.min(w, h) < this.minPx) { warn.textContent = MSG.low(w, h); warn.hidden = false; }
        this.setErr(f, ''); this.photoOk = true; this.refresh();
      };
      img.onerror = () => { URL.revokeObjectURL(url); fail(MSG.read); };
      img.src = url;
    }

    // show=true: hiện lỗi + cuộn tới ô đầu tiên còn thiếu
    validate(show) {
      let first = null;
      const mark = (field, msg) => { if (show) this.setErr(field, msg); if (!first) first = field; };
      this.texts.forEach((f) => {
        const v = f.querySelector('input').value.trim();
        if (!v) mark(f, MSG.empty);
        else if (!ALLOWED.test(v)) mark(f, MSG.chars);
      });
      if (this.photo && !this.photoOk) mark(this.photo, MSG.noFile);
      if (!this.check.checked) mark(this.check.closest('[data-bgt-confirm]'), MSG.confirm);
      if (first && show) {
        first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const el = first.querySelector('input:not([type=hidden])');
        if (el) setTimeout(() => el.focus({ preventScroll: true }), 350);
      }
      return !first;
    }

    refresh() {
      const ok = this.validate(false);
      this.buttons().forEach((b) => { b.setAttribute('aria-disabled', ok ? 'false' : 'true'); b.classList.toggle('bgt-locked', !ok); });
    }
  }
  customElements.define('bgt-personalise', BgtPersonalise);
})();
